export const getConvertedPercent = (number: number) => {
	return +(number * 100).toFixed()
}
